import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import DataTableHelper from "../../../helpers/tables/DataTableHelper"
import Columns from './Columns'
import { resourcesReports,resourcesUnits } from '../../../helpers/backend_helper';
import {DestroyAlertHelper,Alert} from '../../../helpers/alerts/alertHelper';
import { getPolicyUser,getStorageUser } from '../../../helpers/api_helper';
import {Container,ButtonGroup,Button} from "reactstrap";
import Select from 'react-select';
import PreviewPDF from '../../../helpers/previewPDF';
import ButtonHelper from '../../../helpers/ButtonHelper';

const PagosAdministrativosReport = () => {
    const date = new Date();
    const authUser = getStorageUser();
    const [pending, setPending] = useState(false);
    const [modal, setModal] = useState({show:false});
    const [datesDays, setDatesDays] = useState([]);
    const [attendanceModal, setAttendanceModal] = useState({show:false,id:null});
    const [dataPag, setDataPag] = useState({total:0});
    const [yearSelect, setYearSelect] = useState({value:date.getFullYear(),label:date.getFullYear()});
    const [filtSelect,setFiltSelect] = useState({page:1,perPage:20,search:'',orderBy:'id',order:'asc',route_id:null,select:true});
    const [items, setItems] = useState([]);
    const [weeks, setWeeks] = useState([]);
    const [years, setYears] = useState([]);
    const [unit, setUnit] = useState(null);
    const [units, setUnits] = useState([]);

    const numeroDeSemana = fecha => {
        const dia_milisec = 1000 * 60 * 60 * 24,
            semana_dias = 7,
            JUEVES = 4;
        fecha = new Date(Date.UTC(fecha.getFullYear(), fecha.getMonth(), fecha.getDate()));
        let diaDeLaSemana = fecha.getUTCDay(); // Domingo es 0, sábado es 6
        if (diaDeLaSemana === 0) {
            diaDeLaSemana = 7;
        }
        fecha.setUTCDate(fecha.getUTCDate() - diaDeLaSemana + JUEVES);
        const inicioDelAño = new Date(Date.UTC(fecha.getUTCFullYear(), 0, 1));
        const diferenciaDeFechasEnMilisegundos = fecha - inicioDelAño;
        return Math.ceil(((diferenciaDeFechasEnMilisegundos / dia_milisec) + 1) / semana_dias);
    };
    const [weekSelect, setWeekSelect] = useState({value:numeroDeSemana(new Date()),label:`Semana ${numeroDeSemana(new Date())}`});
    const [filters,setFilters] = useState({page:1,perPage:20,search:'',orderBy:'id',order:'asc',companySession:authUser.company_id,year:yearSelect.value,week:numeroDeSemana(new Date())});

    useEffect(() => {
        setPending(true)
        const getResourceReport = async() =>{
            let params={params:filters}
            const response = await resourcesReports('show',params,'pagosAdministrativos');
            setItems(response.data.data)
            setYears(response.arrayDates)
            setDatesDays(response.days)
            setWeeks(response.initWeeks.weeks)
            setDataPag({
                current_page:response.data.current_page,
                from:response.data.from,
                last_page:response.data.last_page,
                links:response.data.links,
                path:response.data.path,
                per_page:response.data.per_page,
                to:response.data.to,
                total:response.data.total,
            })
            
            setPending(false)
        }
        getResourceReport()
    }, [filters])

    useEffect(() => {
        let params={params:filtSelect}
        const getUnits = async() =>{
            const units = await resourcesUnits('get',params);
            setUnits(units.data);
        }
    }, [])

        const getReports = async(type) => {  
        let config = {
            params:filters,
            headers: {'Accept': type==2 ? 'application/pdf':'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'},
            responseType: "blob"
        }
        const response = await resourcesReports('show',config,'pagosAdministrativos');
        if(type==1){
            const url = URL.createObjectURL(new Blob([response]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute(
                'download',
                'Pagos Administrativos.xlsx'
                )
            document.body.appendChild(link)
            link.click()
        }else{
            let nombre = 'Archivo';
            var reader = new FileReader();
            reader.readAsDataURL(response);
            reader.fileName = nombre[1] || nombre[0];
                reader.onloadend = function (name) {
                    name = nombre[0];
                    var base64data = reader.result;
                    setModal({show:true,update:false,url:base64data});
                };    
            }
        }

        const columns = Columns(attendanceModal,setAttendanceModal,setFilters,filters,datesDays);
	document.title = "Reporte Pagos Administrativos";
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div className="col-12">
                        <DataTableHelper tittle="Reporte Pagos Administrativos" filterInp={false} columns={columns} items={items} pending={pending} config={dataPag} filters={filters} setFilters={setFilters}>
                                <ButtonHelper 
                                    addButon={false}
                                    reportButons={true}
                                    actionReportButon={getReports}
                                />
                                <div className="col-sm-3">
                                    <label className="form-label">Año:</label>
                                    <Select
                                        className="basic-single"
                                        classNamePrefix="select"
                                        isClearable={true}
                                        defaultValue={yearSelect}
                                        isSearchable={false}
                                        name="week"
                                        placeholder='Año'
                                        options={years}
                                        onChange={ e => [setYearSelect(e),setFilters({...filters,year:e.value}),setWeeks(e.weeks),setWeekSelect(e.weeks[0])] }
                                    />
                                </div>
                                <div className="col-sm-3">
                                    <label className="form-label">Semana:</label>
                                        <Select
                                            className="basic-single"
                                            classNamePrefix="select"
                                            isClearable={true}
                                            defaultValue={weekSelect}
                                            isSearchable={false}
                                            name="week"
                                            placeholder='Semanas del año'
                                            options={weeks}
                                            onChange={ e => [setWeekSelect(e),setFilters({...filters,week:e.value})] }
                                        />
                                </div>
                                
                                <div className="col-sm-2">
                                    <label className="form-label">Unidad:</label>
                                    <Select
                                        className="basic-single"
                                        classNamePrefix="select"
                                        isClearable={true}
                                        defaultValue={unit}
                                        isSearchable={false}
                                        name="week"
                                        placeholder='Unidades'
                                        options={units}
                                        getOptionLabel={(option) => `${option.type} - ${option.brand}`}
                                        getOptionValue={(option) => `${option.id}`}
                                        onChange={ e => [setUnit(e),setFilters({...filters,unit_id:e ? e.id : null})] }
                                    />
                                </div>
                                
                        </DataTableHelper>
                    </div>
                </Container>
                {modal.show && (
                    <PreviewPDF modalPdf={modal} setModalPdf={setModal} />
                )}
            </div>
        </React.Fragment>
    );
};

export default PagosAdministrativosReport;